import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const StatementQuestion = lazyWithPreload(
  () => import('./StatementQuestion'),
)
export const ChatStatementQuestion = lazyWithPreload(
  () => import('./ChatStatementQuestion'),
)
export const StatementQuestionVariant2 = lazyWithPreload(
  () => import('./StatementQuestionVariant2'),
)
